import { c as _c } from "react/compiler-runtime";
import { Avatar, Stack, Tooltip, Typography, useTheme } from "@mui/material";
import { getDifficultyColor } from "#/entities/difficulty/lib/getDifficultyColor";
import { difficultyLabels } from "#/entities/difficulty/model/difficultyLabels";
import type { RouterOutputs } from "#/shared/api";
import { getImageUrl } from "#/shared/lib";
import { NewLabel } from "#/shared/ui/atoms/NewLabel";
import { ProblemLinkButton } from "#/shared/ui/atoms/ProblemLinkButton";
export type ProjectInfoProps = {
  project?: RouterOutputs["project"]["getBySlug"];
};
export const ProjectInfo: React.FC<ProjectInfoProps> = t0 => {
  const $ = _c(30);
  const {
    project
  } = t0;
  const theme = useTheme();
  if (!project) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      alignItems: "center"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== project.title) {
    t3 = <Typography>{project.title}</Typography>;
    $[2] = project.title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== project.createdAt || $[5] !== project.isNew) {
    t4 = project.isNew && <NewLabel createdAt={project.createdAt} />;
    $[4] = project.createdAt;
    $[5] = project.isNew;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== project.lcLink) {
    t5 = project.lcLink && <ProblemLinkButton problemLink={project.lcLink} />;
    $[7] = project.lcLink;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <Stack direction="row" spacing={1} sx={t2}>{t3}{t4}{t5}</Stack>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      alignItems: "center",
      minWidth: 10,
      overflow: "hidden"
    };
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== project.difficulty || $[15] !== theme) {
    t8 = getDifficultyColor(theme, project.difficulty);
    $[14] = project.difficulty;
    $[15] = theme;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = {
      fontSize: 12,
      textOverflow: "ellipsis",
      overflow: "hidden",
      opacity: 0.6,
      color: t8
    };
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const t10 = project.difficulty && difficultyLabels[project.difficulty];
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = <Typography variant="subtitle1" sx={t9}>{t10}</Typography>;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== project.author) {
    t12 = project.author?.bucketImage && <Tooltip title={`Author: ${project.author.name}`} arrow={true}><Avatar src={getImageUrl(project.author.bucketImage)} alt={`${project.author.name} avatar`} sx={{
        height: 24,
        width: 24
      }} /></Tooltip>;
    $[22] = project.author;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t11 || $[25] !== t12) {
    t13 = <Stack direction="row" spacing={1} sx={t7}>{t11}{t12}</Stack>;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13 || $[28] !== t6) {
    t14 = <Stack direction="row" spacing={1} sx={t1}>{t6}{t13}</Stack>;
    $[27] = t13;
    $[28] = t6;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
};